(ns assemble.templates-page.drawer.db
  (:require [assemble.component.file-tree.db]
            [assemble.resource.template :as template]
            [common.db.effects.promise]
            [re-frame.core :as rf]))

(rf/reg-event-fx :assemble.templates-page/drawer-close
  (fn [_]
    {:router/update-query #(dissoc % :file)}))

(rf/reg-event-fx :assemble.templates-page/set-current-file
  (fn [_ [_ data]]
    {:router/update-query #(assoc % :file (:id data))}))

(rf/reg-event-fx ::rename-template
  [(rf/inject-cofx :sub :assemble.page.assets.file-tree/current-node-id)]
  (fn [{folder-node-id :assemble.page.assets.file-tree/current-node-id} [_ resolve reject template-id template-name]]
    {:fx [[:dispatch [::template/patch
                      [::template/template-patch-success folder-node-id resolve]
                      [::template/template-patch-failure reject]
                      template-id {:name template-name}]]]}))

(rf/reg-event-fx ::download-ae-template
  (fn [_ [_ base-url name]]
    {:fx [[:dispatch [::template/download-ae-template
                      [::template-download-success nil]
                      [::template-download-failure nil]
                      base-url name]]]}))

(rf/reg-event-fx ::download-display-template
  (fn [_ [_ template-id creation-tool]]
    {:fx [[:dispatch [::template/download-display-template
                      [::template-download-success nil]
                      [::template-download-failure nil]
                      template-id
                      creation-tool]]]}))

(rf/reg-event-fx ::template-download-success
  (fn [_ [event resolve response]]
    {:fx [[:promise/resolve resolve]
          [:binary/download response]
          [:dispatch [:toaster-bus/add {:id ::template-download-success
                                        :type :success
                                        :message "The template was downloaded successfully"
                                        :event event}]]
          [:dispatch [:loader/close]]]}))

(rf/reg-event-fx ::template-download-failure
  (fn [_ [event reject response]]
    {:fx [[:dispatch [:toaster-bus/add {:id ::template-download-failure
                                        :type :error
                                        :message "Something went wrong while downloading the template."
                                        :event event
                                        :response response}]]
          [:promise/reject reject]
          [:dispatch [:loader/close]]]}))

(rf/reg-event-fx ::template-patch-success
  (fn [{:keys [db]} [_ folder-node-id resolve response]]
    ;; Use the PATCH request response to update the list in app-db
    ;; NOTE: The response is missing :latestRevision and :revisions keys,
    ;; but we merge the document with the existing data so we keep those from the
    ;; list response. This is OK for rename and archive operations.
    {:db (template/update-template-query-result db folder-node-id (dissoc response :revisionIds))
     :fx [[:promise/resolve resolve]
          [:dispatch [:toaster-bus/add {:id ::template-patch-success
                                        :type :success
                                        :message "Template changes saved"}]]]}))

(rf/reg-event-fx ::template-patch-failure
  (fn [_ [event reject response]]
    {:fx [[:dispatch [:toaster-bus/add {:id ::template-patch-failure
                                        :type :error
                                        :message "Something went wrong while saving the template changes."
                                        :event event
                                        :response response}]]
          [:promise/reject reject]]}))
